var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"icon icon-administracao_cargos"})
}
var staticRenderFns = []

export { render, staticRenderFns }